import api from '@/api/fetchClient'

export default {
  getEmployees(params = {}) {
    let url = 'salaries/employees'
    const queryParams = []

    if (params.search) {
      queryParams.push(`search=${encodeURIComponent(params.search)}`)
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&')
    }

    return api.get(url, { authorized: true })
  },

  getEmployeeById(partyId) {
    return api.get(`salaries/employees/${partyId}`, { authorized: true })
  },

  createEmployee(payload) {
    return api.post('salaries/employees', payload, { authorized: true })
  },

  updateEmployee(partyId, payload) {
    return api.put(`salaries/employees/${partyId}`, payload, { authorized: true })
  },

  deleteEmployee(partyId) {
    return api.delete(`salaries/employees/${partyId}`, { authorized: true })
  },

  getStats() {
    return api.get('salaries/stats', { authorized: true })
  }
}
